import { Pipe, PipeTransform } from '@angular/core';

import { PortalOrderNode } from '@app/services/api/api.types';
import { State } from '@app/services/state/state.service';
import { calculateMaxBalanceAmount } from '@app/utils/utils';

@Pipe({
  name: 'getMaxBalanceAmount',
})
export class GetMaxBalanceAmountPipe implements PipeTransform {
  transform(
    maxBalanceAmount = 0,
    clientBalanceAmount = 0,
    state: State,
    portalOrder?: PortalOrderNode | null,
  ) {
    return calculateMaxBalanceAmount(maxBalanceAmount, clientBalanceAmount, state, portalOrder);
  }
}
